import FeedbackPage from '@app-studio-web/ui/pages/FeedbackPage'
import { useTranslation } from 'react-i18next'
import { useSubmit } from 'react-router-dom'
import { getAllAnswers } from '../../utils/onboardingStorage'

export default function SleepHoursManagement() {
  const submit = useSubmit()
  const { t } = useTranslation()
  const allAnswers = getAllAnswers()

  // Get sleep hours answer
  const sleepHoursAnswer = allAnswers.sleepHours?.answer_key

  // Check if user sleeps 7 hours or more
  const sleepsMoreThan7Hours =
    sleepHoursAnswer === '7–8 hours' || sleepHoursAnswer === '8+ hours'

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    submit(event.currentTarget)
  }

  // Render content based on sleep hours
  if (sleepsMoreThan7Hours) {
    // User sleeps 7 hours or more
    return (
      <FeedbackPage
        emoji="💡"
        heading={t('pages.onboarding.sleepHoursManagement.heading2')}
        text={t('pages.onboarding.sleepHoursManagement.description2')}
        onSubmit={handleSubmit}
      />
    )
  }

  // User sleeps less than 7 hours
  return (
    <FeedbackPage
      emoji="💡"
      heading={t('pages.onboarding.sleepHoursManagement.heading1')}
      text={t('pages.onboarding.sleepHoursManagement.description1')}
      onSubmit={handleSubmit}
    />
  )
}
